<script setup lang="ts">
defineProps<{
  canGoBack: boolean
  goBack: () => void
}>()

const productContent = useProductContentStore()
</script>

<template>
  <div class="flex w-full justify-center gap-4">
    <header
      class="pointer-events-none top-0 z-30 flex h-fit w-[90%] max-w-[90em] items-center justify-between gap-4 overflow-hidden py-4 transition-all duration-200 md:justify-start"
    >
      <UButton
        class="pointer-events-auto"
        circle
        aria-label="Tilbake til kapittelet"
        theme="white"
        variant="filled"
        :to="productContent.activeSubject?.frontendHref"
      >
        <template #prepend>
          <UIcon name="minimize" />
        </template>
      </UButton>
      <UButton
        v-if="canGoBack"
        class="pointer-events-auto"
        pill
        theme="white"
        variant="filled"
        @click="goBack"
      >
        <template #prepend>
          <UIcon name="arrow-up" size="sm" />
        </template>
        Forrige
      </UButton>
    </header>
  </div>
</template>
